module.exports = __webpack_public_path__ + "static/img/groundabout4.9ab41df5.png";